import { useForm } from "react-hook-form";
import React from "react";
import {
  ActionPortal,
  Col,
  DefaultActionButtons,
  Form,
  FormGroup,
  FormLabel,
  Input,
  Row,
  Step,
  MaskedInput,
  Text,
} from "components";

import { inputsValidations } from "validations/inputsFieldsValidations";

import { StepPropTypes } from "../../constants/propTypes";
import TabContainer from "components/tabContainer";

export default function Responsible(props) {
  const {
    theme,
    onSubmit,
    initialValues: { responsible, gettingStarted },
  } = props;

  const { control, errors, formState, handleSubmit, register, watch } = useForm(
    {
      mode: "all",
      defaultValues: responsible,
    }
  );

  const fieldsValidations = inputsValidations.BR;

  const { isValid } = formState;

  const cnpjLength = 14;
  const cpfLength = 11;

  const submitForm = (e) => {
    e.preventDefault();

    handleSubmit((data) => {
      onSubmit({ 
        ...data,
        gettingStarted 
      });
    })();
  };

  return (
    <Step {...props}>
      <TabContainer step={1} totalSteps={3}>
        <section
          style={{
            gap: 28,
            display: "flex",
            flexDirection: "column",
            marginBottom: 22,
          }}
        >
          <h1
            style={{
              fontWeight: 430,
              fontSize: 24,
            }}
          >
            Olá <span role="img" aria-label="Hello">👋</span> Seja bem-vindo
          </h1>
          <article
            style={{
              gap: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 430,
                fontSize: 16,
              }}
            >
              Vamos começar! Quem vai assinar?
            </p>
          </article>
        </section>
        <Form onKeyPress={(e) => e.key === "Enter" && submitForm(e)}>
          {gettingStarted &&
            gettingStarted.document.trim().length === cnpjLength && (
              <Row form>
                <Col md="12">
                  <FormGroup>
                    <FormLabel for="company_name">Razão social</FormLabel>
                    <Input
                      type="text"
                      name="company_name"
                      id="company_name"
                      placeholder="Razão social da empresa contratante"
                      invalid={!!errors.company_name}
                      maxLength={256}
                      innerRef={register({
                        required: fieldsValidations.required,
                        ...fieldsValidations.communText,
                      })}
                    />
                    <Text
                      fontSize={12}
                      color={"#E65845"}
                      style={{ marginTop: "8px" }}
                    >
                      {errors.company_name?.message}
                    </Text>
                  </FormGroup>
                </Col>
              </Row>
            )}
          {gettingStarted &&
            gettingStarted.document.trim().length === cnpjLength && (
              <Row form>
                <Col md="12">
                  <FormGroup>
                    <FormLabel for="name">CNPJ da contratante</FormLabel>
                    <MaskedInput
                      control={control}
                      name="companyDocument"
                      defaultValue={gettingStarted.document}
                      format="cnpj"
                      disabled={true}
                      errors={errors}
                      placeholder="Ex.: 99.521.351/0001-05"
                      rules={{
                        required: fieldsValidations.required,
                        validate: () =>
                          fieldsValidations.companyDocument(
                            watch("companyDocument")
                          ),
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}
          <Row form>
            <Col md="8">
              <FormGroup>
                <p
                  for="responsible"
                  style={{
                    fontSize: 14,
                    marginBottom: 4
                  }}
                >
                  Responsável legal
                </p>
                <Input
                  type="text"
                  name="responsible"
                  id="responsible"
                  placeholder="Nome de quem vai assinar o contrato"
                  invalid={!!errors.responsible}
                  innerRef={register({
                    required: fieldsValidations.required,
                    ...fieldsValidations.peopleName,
                  })}
                />
                <Text
                  fontSize={12}
                  color={"#E65845"}
                  style={{ marginTop: "8px" }}
                >
                  {errors.responsible?.message}
                </Text>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <p
                  for="name"
                  style={{
                    fontSize: 14,
                    marginBottom: 4
                  }}
                >
                  CPF do responsável legal
                </p>
                <MaskedInput
                  control={control}
                  name="responsibleDocument"
                  defaultValue={
                    gettingStarted &&
                    gettingStarted.document.trim().length === cpfLength
                      ? gettingStarted.document
                      : ""
                  }
                  format="cpf"
                  errors={errors}
                  placeholder="Ex.: 468.123.152-23"
                  rules={{
                    required: fieldsValidations.required,
                    validate: () =>
                      fieldsValidations.peopleDocument(
                        watch("responsibleDocument")
                      ),
                  }}
                />
              </FormGroup>
            </Col>
          </Row>
          <ActionPortal>
            <DefaultActionButtons
              theme={theme}
              isValid={isValid}
              nextButtonStyle={{
                customBackgroundColor: theme.newPalette.background.purple,
                customIconColor: theme.colors.text.white,
                customTextColor: theme.colors.text.white,
                title: "Próximo Passo",
              }}
              onSubmit={() => handleSubmit((data) => {
                onSubmit({ 
                  ...data,
                  gettingStarted 
                });
              })()}
            />
          </ActionPortal>
        </Form>
      </TabContainer>
    </Step>
  );
}

Responsible.propTypes = StepPropTypes;
